module.exports = __webpack_public_path__ + "static/media/logo.1be0c7e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Xpower/logo.svg
// module id = 618
// module chunks = 0